export const DEFAULT_QUICK_SEARCH_SUGGESTIONS = {
  neckermann: {
    nl: [
      {
        title: 'Suggesties',
        type: 'suggestions',
        items: [
          {
            title: 'Griekenland',
            url: 'https://neckermann.be/nl/vakanties/vliegvakanties/griekenland',
          },
          {
            title: 'Turkije',
            url: 'https://neckermann.be/nl/vakanties/vliegvakanties/turkije',
          },
          {
            title: 'Last Minute vakanties',
            url: 'https://neckermann.be/nl/vakanties/vliegvakanties/last-minutes',
          },
          {
            title: 'Egypte',
            url: 'https://neckermann.be/nl/vakanties/vliegvakanties/egypte',
          },
          {
            title: 'Vliegvakanties',
            url: 'https://neckermann.be/nl/vakanties/vliegvakanties',
          },
          {
            title: 'Exotische vakanties',
            url: 'https://neckermann.be/nl/vakanties/exotische-vakanties',
          },
          {
            title: 'Autovakanties Duitsland',
            url: 'https://neckermann.be/nl/vakanties/autovakanties/duitsland',
          },
        ],
      },
    ],
    fr: [
      {
        title: 'Suggestions',
        type: 'suggestions',
        items: [
          {
            title: 'Grèce',
            url: 'https://neckermann.be/fr/vacances/vacances-en-avion/grece',
          },
          {
            title: 'Turquie',
            url: 'https://neckermann.be/fr/vacances/vacances-en-avion/turquie',
          },
          {
            title: 'Vacances Last Minute',
            url: 'https://neckermann.be/fr/vacances/vacances-en-avion/last-minutes',
          },
          {
            title: 'Egypte',
            url: 'https://neckermann.be/fr/vacances/vacances-en-avion/egypte',
          },
          {
            title: 'Vacances en avion',
            url: 'https://neckermann.be/fr/vacances/vacances-en-avion',
          },
          {
            title: 'Vacances Exotiques',
            url: 'https://neckermann.be/fr/vacances/vacances-exotiques',
          },
          {
            title: 'Vacances en voiture France',
            url: 'https://neckermann.be/fr/vacances/vacances-en-voiture/france',
          },
        ],
      },
    ],
  },
}
